// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { isEmpty } from '@automator/utilities';

// Import style for web component
import styles from './web-component-style.scss';

// eslint-disable-next-line require-jsdoc
@customElement( 'uo-snackbar' )
export class AutomatorSnackbar extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	// The message of the snackbar
	@property( { type: String } ) accessor message = '';

	// Whether the element will be `absolute` (default) or `fixed`
	@property( { type: Boolean, attribute: 'is-fixed' } ) accessor isFixed = false;

	// The position of the snackbar
	@property( { type: String } ) accessor position = 'bottom-center'; // [bottom|top]-[left|center|right]

	// The duration in ms. -1 to make it infinite
	@property( { type: Number } ) accessor duration = 5000;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div 
				class="snackbar"
				position=${ this.position }
				?is-fixed=${ this.isFixed }
			>
				<div class="snackbar-icon">
					<slot name="icon"></slot>
				</div>

				<div class="snackbar-message">
					${ this.message }
				</div>

				<div class="snackbar-action">
					<slot name="action"></slot>
				</div>
			</div>
		`;
	}

	/**
	 * Deletes the snackbar automatically after the defined milliseconds
	 */
	firstUpdated() {
		if ( isEmpty( this.duration ) || this.duration === -1 ) {
			return;
		}

		setTimeout( () => {
			// Destroy
			this.remove();
		}, this.duration )
	}
}